import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { useI18n } from "../i18n/I18nContext";
import { toast } from "sonner";

export default function AdminLogin() {
  const { t } = useI18n();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/auth/login", { email, password });
      localStorage.setItem("admin_token", r.data.token);
      toast.success("OK");
      nav("/admin");
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-[70vh] flex items-center justify-center px-6 py-16" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md border border-border p-10 bg-white">
        <div className="label-caps text-muted-foreground mb-4">Savi Admin</div>
        <h1 className="font-hand text-4xl mb-10">{t("admin.login")}</h1>
        <div className="space-y-6">
          <div>
            <label className="label-caps text-muted-foreground block mb-2">{t("admin.email")}</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full bg-transparent border-b border-border py-2 outline-none focus:border-[hsl(var(--primary))]"
              data-testid="admin-email-input"
            />
          </div>
          <div>
            <label className="label-caps text-muted-foreground block mb-2">{t("admin.password")}</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full bg-transparent border-b border-border py-2 outline-none focus:border-[hsl(var(--primary))]"
              data-testid="admin-password-input"
            />
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full justify-center" data-testid="admin-signin-btn">
            {loading ? "…" : t("admin.signIn")}
          </button>
        </div>
      </form>
    </main>
  );
}
